import { helper } from '@ember/component/helper';

import { set } from 'rise-ui/utils/object.js';

export default helper(function metaToggleHelper([ metaArr, index, key ]) {
  return () => {
    const meta = metaArr?.[index];
    if (!meta) {
      return;
    }
    const value = !meta[key];
    set(meta, key, value);
    metaArr.replace(index, 1, [ meta ]);
    return value;
  };
});
